// @core/api/endpoints/authn/list_oauth2_clients.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListOAuth2ClientsResponse,
} from '../../../types/authn';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authn';

/**
 * List OAuth2 clients
 * Returns a paginated list of OAuth2 clients registered on the platform. Supports filtering by search term and enabled status.
 */
export async function ListOAuth2Clients(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListOAuth2ClientsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/clients`;
  const requestOptions = options;
  return client.get<ListOAuth2ClientsResponse>(requestPath, { ...requestOptions, params });
}
